import React from 'react';
import {
  AD_LIGHT_HTML_ATTR,
  AD_LIGHT_STORAGE_KEY,
  FREESTAR_STICKY_FOOTER_DISMISS_STORAGE_KEY,
  FREESTAR_STICKY_FOOTER_MOBILE_ENABLED,
  FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT,
  DATED_ARTICLE_PATH_REGEX,
} from '@benzinga/ads-utils';

const FREESTAR_QUEUE_BOOTSTRAP = `
(function () {
  try {
    var forceAds = /[?&]adlight=(false|0)(?:&|$)/.test(location.search);
    var adLight =
      !forceAds &&
      (document.documentElement.getAttribute('${AD_LIGHT_HTML_ATTR}') === 'true' ||
        localStorage.getItem('${AD_LIGHT_STORAGE_KEY}') === 'true');
    var freestar = window.freestar || {};
    freestar.queue = freestar.queue || [];
    freestar.config = freestar.config || {};
    freestar.config.enabled_slots = freestar.config.enabled_slots || [];
    window.freestar = freestar;
    window.freestarReactCompontentLoaded = true;
    var dismissed = localStorage.getItem('${FREESTAR_STICKY_FOOTER_DISMISS_STORAGE_KEY}') === 'true';
    if (adLight) {
      freestar.config.disabledProducts = Object.assign({}, freestar.config.disabledProducts || {}, {
        googleInterstitial: true,
        stickyFooter: true,
        stickyRail: true,
      });
    } else if (dismissed) {
      freestar.config.disabledProducts = Object.assign(freestar.config.disabledProducts || {}, { stickyFooter: true });
    } else {
      ${
        FREESTAR_STICKY_FOOTER_MOBILE_ENABLED
          ? `if (window.matchMedia('(max-width: 767px)').matches) {
        var path = location.pathname;
        var isArticle =
          path === '/article' ||
          path.indexOf('/article/') === 0 ||
          /^\\/content\\/\\d+(?:\\/|$)/.test(path) ||
          path.indexOf('/pressreleases/') === 0 ||
          path.indexOf('/press-releases/') === 0 ||
          path.indexOf('/secfilings/') === 0 ||
          /${DATED_ARTICLE_PATH_REGEX.source}/.test(path);
        if (!isArticle) {
          freestar.config.disabledProducts = Object.assign({}, freestar.config.disabledProducts || {}, { stickyFooter: true });
        } else {
          freestar.queue.push(function () {
            if (typeof window.freestar.newStickyFooter === 'function') {
              window.freestar.newStickyFooter(${JSON.stringify(FREESTAR_STICKY_FOOTER_MOBILE_PLACEMENT)});
            }
          });
        }
      }`
          : `if (window.matchMedia('(max-width: 767px)').matches) {
        freestar.config.disabledProducts = Object.assign(freestar.config.disabledProducts || {}, { stickyFooter: true });
      }`
      }
    }
  } catch (error) {}
})();
`.trim();

export const FreestarQueueBootstrap: React.FC = () => (
  <script
    // eslint-disable-next-line benzinga/no-unsanitized-innerhtml -- static Freestar queue bootstrap; sanitizeHTML is for HTML and would corrupt JS
    dangerouslySetInnerHTML={{ __html: FREESTAR_QUEUE_BOOTSTRAP }}
    data-cfasync="false"
    id="freestar-queue"
  />
);
